module.exports = __webpack_public_path__ + "img/hezuohuoban.870e3dfc.png";